<div class="ui-g loyalty-cluster" *ngIf="translations && acmTypePermission">
  <div class="ui-g-12">

    <app-kontable #table
                  title = "{{ 'acm_type.acm_type_title' | translate }}"
                  [columns] = "['id', 'description', 'acm_type_code',
                  { field: 'flg_operation', bodyTemplate: operationTemplate, filterTemplate: operationFilter, filterType: customFilter, title: 'acm_type.flg_operation' },
                  { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: selectFilter, filterTemplate: stateFilter, filterOptions: {values: listStates}}
                  ]"
                  [titles] = "['common.id', 'common.description', 'acm_type.acm_type_code', 'acm_type.flg_operation']"
                  [paginationType]="serverPagination"
                  [showInfoButton]="false"
                  [showRecoverButton]="true"
                  [showGlobalFilter]="false"
                  [showDetailsButton]="false"
                  [showAddButton]="true"
                  [service]="acmTypeService"
                  [(fireNewDataAvailable)]="newDataAvailable"
                  [servicePermissions]="acmTypePermission"
                  (onAdd)="addNew($event)"
                  (onEdit)="edit($event)"
                  (onRecover)="recover($event)"
                  (onRemove)="remove($event)">

      <ng-template #operationTemplate data-testid="operationTemplate" let-row>{{showOperation(row)}}</ng-template>

      <ng-template #operationFilter data-testid="operationFilter" let-col>
        <p-dropdown [options]="listOperations" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" styleClass="ui-column-filter" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>



      <ng-template #stateFilter data-testid="stateFilter" let-col>
          <p-dropdown [options]="listStates" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
      </ng-template>

      <ng-template #stateTemplate data-testid="stateTemplate" let-row class="deleted-row">
        <span *ngIf="row.flg_state && row.flg_state == '1'" class="fa fa-trash-o" title="{{'common.deleted' | translate}}"></span>
      </ng-template>


    </app-kontable>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-acm-type/loyalty-acm-type.component.html